module.exports = __webpack_public_path__ + "static/media/CloseCircleFilled.fd36d243.svg";